import React, { useState } from 'react';
import { Button, Modal, Select, Text } from 'v3/components';
import { fetchVehicle } from 'utils/fetches';
import { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';
import { useFleetManagement } from '../../shared';
import { Row, Col } from 'react-bootstrap';

function CreateNewRegister() {
  const {
    newRegisterModal: modalHook,
    handleGetData
  } = useFleetManagement();

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const snackbar = useSnackbar();

  const handleCreateRegister = async () => {
    try {
      setLoading(true);

      const { data } = await cooperplaceApi.post(`fleet/management/vehicleManagement`, {
        vehicleIds: vehicles.map((vehicle) => vehicle.id),
      });

      const errors = data?.error.map((error) => `${error.vehicle} ${error.description}`);

      if (errors && errors.length > 0) {

        snackbar.show(
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {errors.map((error) => (
              <Text key={error}>{error}</Text>
            ))}
          </div>,
          { type: 'error' },
        );

        return;
      }

      setVehicles([]);

      modalHook.close();

      snackbar.show(<Text>Registros adicionados com sucesso</Text>, {
        type: 'success',
      });

      await handleGetData({ page: 1, not_loading: true });

    } catch (error) {
      snackbar.show('Ocorreu um erro ao adicionar os registros', {
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setVehicles([]);
    modalHook.close();
  };

  return (
    <Modal
      show={modalHook.isOpen}
      heading="Adicionar novo veículo"
      size="lg"
      handleClose={handleClose}
      body={
        <Row style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <Col>
            <Text>Adicione todos os veículos que gostaria de importar para a gestão de frotas</Text>
          </Col>
          <Col>
            <Select.Async
              onSearch={fetchVehicle}
              label="Veículos"
              getOptionLabel={(option) => option.plate}
              getOptionValue={(option) => option.id}
              onChange={(vehiclesOption) => {
                return vehiclesOption?.length > 20
                  ? snackbar.show(<Text>Não é possível inserir mais de 20 veículos.</Text>, {
                    type: 'error',
                  })
                  : setVehicles(vehiclesOption || []);
              }}
              value={vehicles}
              multiple
            />
          </Col>
        </Row>
      }
      footer={
        <>
          <Button onClick={handleClose} variant="secondary" modal>
            Cancelar
          </Button>
          <Button loading={loading} onClick={handleCreateRegister} modal>
            Adicionar registros
          </Button>
        </>
      }
    />
  );
}

export default CreateNewRegister;
